<template>
  <input-base
      ref="base"
      :read-only="readOnly"
      :editor-mode="editorMode"
      :validated-field="formField"
      :field-config="fieldConfig"
      :static-label="label"
      :with-select="withSelect"
      :grid-editor="gridEditor"
      :open-from-grid="openFromGrid"
      :mode="mode"
  >
    <template slot="readOnly">
      <div v-html="formattedValue"></div>
    </template>
    <template slot="editor">
      <b-form-input
                    v-on:keydown.esc="escTrigger"
                    @focusout="focusOut"
                    ref="input"
                    type="number"
                    v-model="rawValue"
                    :placeholder="placeholder"
                    :autocomplete="autocomplete"
                    :step="step.value?step.value:step"
                    @keyup="fixFormatDelayed"
                    @change="fixFormat"
      ></b-form-input>
    </template>
  </input-base>
</template>


<script>
import ValidatedField from "@/validation/ValidatedField";

import InputBase from "@/components/inputs/InputBase";
import BigDecimal from "@/server/BigDecimal";
import DecimalWithCurrency from "@/server/com/silkplm/rpc/dto/DecimalWithCurrency";
import FormValidatedField from "@/components/forms/FormValidatedField";
import FormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig";
import Currency from "@/server/com/silkplm/model/plm/dictionaries/Currency";

const MAX_DECIMAL_LENGTH = 50;

export default {
  name: "ReachDecimalInput",
  components: {InputBase},
  created() {
    this.sanitized = undefined;
    if (this.dataType === "DecimalWithCurrency") {
      this.rawValue = "" + (this.formField.value?.decimal ?? "");
    } else {
      if (this.formField.value) {
        this.rawValue = "" + (this.formField.value ?? "");
      } else {
        this.rawValue = "" + (this.formField.value ?? "");
      }

    }
    this.formatVal();
  },
  async mounted() {
    if (this.initialFocus) {
      let canInitialFocus = true;
      if (this.formField?.validatedForm?.formConfig?.onlyEmbedded) {
        canInitialFocus = false;
      }
      if (canInitialFocus) {
        setTimeout(() => this.afterMounted(), 200);
      }
    }
  },

  methods: {
    setRegion(){

    },
    formatVal() {
      if (this.dataType === "DecimalWithCurrency") {
        this.formattedValue = (this.formField.value?.decimal != null && this.formField.value?.decimal !== "") ?
            (this.roundTheValue(this.formField.value?.decimal)) + '' : "";
      } else {
        this.formattedValue = (this.formField.value?.value !== undefined && this.formField.value?.value !== "")
            ? (this.roundTheValue(this.formField.value?.value)) : "";
      }
    },

    roundTheValue(val) {
      if (this.roundMethod === "UP") {
        let number = Number(val);
        number = number.toFixed(this.roundTo);
        return number;
      } else {
        return this.roundDown(val, this.roundTo);
      }
    },

    afterMounted() {
      if (!this.readOnly) {
        const el = this.$refs.input;
        el.focus();
      }
    },

    escTrigger(event) {
      this.$emit('esc');
    },

    focusOut() {
      if (this.lastKey !== "Enter") {
        this.fixFormat();
      }
      this.formField?.validate();
        if (this.pendingTimer) {
          clearTimeout(this.pendingTimer);
      }
    },

    fixFormatDelayed() {

        // EventBus.$emit('Decimal', false);
        if (this.pendingTimer) {
          clearTimeout(this.pendingTimer);
          this.pendingTimer = null;
        }
        this.pendingCheck = this.$refs.input?.$el.value;

        this.pendingTimer = setTimeout(() => {
          clearTimeout(this.pendingTimer);
          this.pendingTimer = null;

          if (this.pendingCheck !== this.$refs.input?.$el.value) {
            this.fixFormatDelayed();
            return
          }
          this.fixFormat(true);
        }, 100);
    },

    sanitize(val) {
      let sanitized = "";
      const digits = /[0-9]/;

      for (let i = 0; i < val.length; i++) {
        const char = val[i];
        if (sanitized === "" && char === '-') {
          sanitized += "-";
          continue;
        }
        if (digits.test(char) || char === ',' || char === '.') {
          sanitized += char;
        }
      }
      return sanitized;
    },

    toFixedPrecision(sanitized) {
      let cleanValue = new BigDecimal(sanitized);
      let step = parseFloat(this.step.value?this.step.value:this.step);
      if (!step || step < 0) {
        step = 1;
      }

      let precision = Math.ceil(-Math.log10(step));
      if (precision < 0) {
        precision = 0;
      }

      let pow = new BigDecimal(Math.pow(10, precision));

      let cut = cleanValue.multiply(pow);
      if (cut.compareTo(new BigDecimal(0)) >= 0) {
        cut = cut.floor();
      } else {
        cut = cut.ceil();
      }
      cleanValue = cut.divide(pow, precision);
      return cleanValue;
    },

    updateFormat(){
      // if(this.roundTo){
      //   this.$refs.input.$el.value = Number(this.$refs.input.$el.value).toFixed(this.roundTo);
      //   this.formField.value.decimal.value = Number(this.$refs.input.$el.value).toFixed(this.roundTo);
      // }
    },

    roundDown(value, decimals) {
      const factor = Math.pow(10, decimals);
      let result = Math.floor(value * factor) / factor;
      return result.toFixed(decimals);
    },

    fixFormat(onlyCheck = false) {
      // if(onlyCheck !== true && this.roundTo){
      //   this.formField.value.decimal.value = Number(onlyCheck).toFixed(this.roundTo)
      //   this.formField.value.decimal.value = Number(onlyCheck).toFixed(this.roundTo)
      // }
      try {
        this.lock = true;

        if (this.dataType === "DecimalWithCurrency" && this.formField.value == null) {
          this.formField.value = new DecimalWithCurrency();
          if (this.currency) {
            let currencyEntity = new Currency();
            currencyEntity.id = this.currency;
            currencyEntity.load().then();
            this.formField.value.currency = currencyEntity;
          }
        }

        if (this.sanitized === this.$refs.input?.$el.value && onlyCheck) {
          return;
        }
        // onlyCheck = Number(this.formField.value.decimal.value).toFixed(3)
        let sanitized = this.sanitized = this.sanitize(this.$refs.input.$el.value);

        if (!onlyCheck) {
          this.rawValue = sanitized;
        }

        if (sanitized === "" || sanitized === "-") {
          this.handleEmptyInput(onlyCheck);
          return;
        }

        let cleanValue = this.toFixedPrecision(sanitized);

        if (this.dataType === "DecimalWithCurrency") {
          if (this.formField.value === "") {
            this.formField.value = new DecimalWithCurrency();
          }
          this.formField.value.decimal = cleanValue
          this.formField.notify();
        } else {
          this.formField.value = cleanValue
        }
        if (!onlyCheck && this.$refs?.input?.$el) {
          let roundedTo = 1;
          for (let i = 0; i < this.roundTo; i++) {
            roundedTo *= 10;
          }
          sanitized = this.roundTheValue(sanitized);
          if (this.dataType === "DecimalWithCurrency") {
            this.formField.value.decimal.value = sanitized;
            this.$refs.input.$el.value = "" + this.formField.value.decimal.value;
          } else {
            this.formField.value.value = sanitized;
            this.$refs.input.$el.value = "" + this.formField.value;
          }
          this.formatVal();
        }
      } finally {
        this.lock = false;
      }
    },

    handleEmptyInput(onlyCheck) {
      if (this.dataType === "DecimalWithCurrency") {
        this.formField.value.decimal = null;
        this.formField.notify();
      } else {
        this.formField.value = null;
      }
      if (!onlyCheck) {
        this.$refs.input.$el.value = "";
        this.formatVal();
      }
    },

    setValue(val) {
      if (this.lock || document.activeElement === this.$refs?.input?.$el) {
        this.formField.notify();
        return;
      }

      if (val === null || val === "" || val === undefined) {
        if (this.allowNull) {
          this.rawValue = "";
          this.formatVal();
        } else {
          if (this.min > 0) {
            if (this.dataType === "DecimalWithCurrency") {
              if(!this.formField.value){
                this.formField.value = new DecimalWithCurrency();
              }
              this.formField.value.decimal = this.min;
              this.formField.notify();

            } else {
              this.formField.value = this.min;
            }
          } else {
            if (this.dataType === "DecimalWithCurrency") {
              if(!this.formField.value){
                this.formField.value = new DecimalWithCurrency();
              }
              this.formField.value.decimal = null;
              this.formField.notify();

            } else {
              this.formField.value = new BigDecimal(null);
            }
          }
          if (this.dataType === "DecimalWithCurrency") {
            this.rawValue = "" + this.formField.value.decimal;
            this.formField.notify();

          } else {
            this.rawValue = "" + this.formField.value;
          }
          this.formatVal();
          return;
        }
      }
      if(this.formField.mode === "NEW"){
        if(val === "0"){
          this.rawValue = null;
        }
        else{
          this.rawValue = "" + (val ?? "")
        }
      }
      else{
        this.rawValue = "" + (val ?? "")
      }
      this.formatVal();
    }
  },


  props: {

    readOnly: {type: Boolean, default: false},
    editorMode: {type: Boolean, default: false},
    helpTitle: {type: String, default: ""},
    helpMessage: {type: String, default: ""},
    formField: {type: ValidatedField, default: null},
    fieldConfig: {type: FormFieldConfig, default: null},
    label: {type: String, default: ""},
    hint: {type: String, default: ""},
    dataType: {type: String, default: ""},
    autocomplete: {type: String, default: "false"},
    placeholder: {type: String, default: ""},
    min: {type: BigDecimal, default: null},
    max: {type: BigDecimal, default: null},
    step: {default: 0.01},
    roundTo: {type: Number, default: 2},
    allowNull: {type: Boolean, default: true},
    initialFocus: {type: Boolean, default: false},
    withSelect: {type: Boolean, default: false},
    roundMethod: {type: String, default: "UP"},
    gridEditor: {default: null},
    openFromGrid: {default: false},
    mode: {default: null},
    currency: {default: null}
  },

  watch: {
    readOnly: function (val){
    },
    'formField': async function (val) {
      this.setValue(val?.value?.value);
    },
    'formField.value.decimal': async function (val) {
      if (this.dataType === "DecimalWithCurrency") {
        this.setValue(val?.value ?? val);
      }
    },
    'formField.value': async function (val) {
      if (this.dataType === "BigDecimal") {
        this.setValue(val?.value);
      }
    },

    'formField.computeFieldInProgress': function (inProgress) {
      this.loading = inProgress;
      if (inProgress) {
        this.formattedValue = null;
        if (this.dataType === "DecimalWithCurrency") {
          if (this.formField.value?.decimal) {
            this.formField.value.decimal = null;
          }
        } else {
          if (this.formField.value) {
            this.formField.value = null;
          }
        }
      } else {
        this.formatVal();
      }
    }
  },

  data: () => ({
    /** Function */
    format: null,
    formattedValue: '',
    rawValue: '',
    lastKey: null,
    loading: false,
  })
}
</script>

<style scoped>

</style>